
<template>
  <div>
    <base-card :with_title="false" :with_actions="false">
      <template slot="content">
        <v-form ref="movementForm">
          <v-row justify='end' align='center' class="pa-3">
            <v-col class="pa-1" cols="12" sm="6" md="12" lg="3">
              <!-- <v-row align='center'> -->
                <!-- <div>{{$tc('financials.description_form_label')}}</div> -->
                <v-text-field rounded outlined dense class="rounder" 
                  :label="$tc('financials.description_form_label')"
                  v-model="new_movement.name"
                  :rules="required"
                ></v-text-field>
              <!-- </v-row> -->
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="4" lg="3">
              <v-text-field rounded outlined dense class="rounder" 
                :label="$tc('financials.value_form_label')"
                prefix="R$"
                v-model="new_movement.value"
                :rules="not_zero"
                v-currency="currency"
              ></v-text-field>
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3" lg="3">
              <v-select rounded outlined dense class="rounder" 
                :label="$tc('financials.kind_form_label')"
                :items="kind_options"
                item-text="text"
                item-value="value"
                v-model="new_movement.kind"
                :rules="required"
              ></v-select>
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3" lg="3">
              <!-- <v-text-field rounded outlined dense class="rounder" 
                :label="$tc('financials.due_form_label')"
                v-model="new_movement.due_date"
                :rules="required"
              ></v-text-field> -->
              <vc-date-picker v-model="new_movement.due_date">
                  <template v-slot="{ inputValue, togglePopover }">
                    <v-text-field rounded outlined dense class="rounder" 
                      :label="$tc('financials.due_form_label')"
                      :value="$dayjs(new_movement.due_date).format('DD/MM/YYYY')"
                      :rules="required"
                      @focus="togglePopover()"
                      readonly
                    ></v-text-field>
                  </template>
                </vc-date-picker>
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="2" lg="3" align="right">
              <v-btn rounded width="130px" color="primary" class="font-weight-bold text-capitalize mt-n7"
                @click="submitMovement()"
              >
                {{ $t('add') }}
              </v-btn>
            </v-col>
            <!-- <v-col class="pa-1" cols="12" sm="6" md="4" lg="3">5</v-col> -->
            <!-- <v-col class="pa-1" cols="12" sm="6" md="4" lg="3">5</v-col> -->
          </v-row>
        </v-form>
      </template>
    </base-card>

    <dialog-loading v-if="loading" loadingText="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import {CurrencyDirective} from 'vue-currency-input'

export default {
  name: 'MovementCreate',
  mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  directives: {
    currency: CurrencyDirective,
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      new_movement: {
        project_id: null,
        company_id: null,
        name: null,
        value: '0.00',
        description: null,
        due_date: this.$dayjs().endOf('month').format('YYYY-MM-DD'),
        kind: 'income',
        category: null,
        status: 'open',
        done_at: null,
      },

      kind_options: [
        {text: this.$t('financials.kinds.income'), value: 'income'},
        {text: this.$t('financials.kinds.outcome'), value: 'outcome'},
      ],
      
      status_options: [
        {text: this.$t('financials.statuses.open'), value: 'open'},
        {text: this.$t('financials.statuses.payed'), value: 'payed'},
        {text: this.$t('financials.statuses.overdue'), value: 'overdue'},
        {text: this.$t('financials.statuses.canceled'), value: 'canceled'},
      ],

      loading: false,
    }
  },
  methods: {
    resetMovement(){
      this.new_movement = {
        project_id: null,
        company_id: null,
        name: null,
        value: '0.00',
        description: null,
        due_date: this.$dayjs().endOf('month').format(),
        kind: 'income',
        category: null,
        status: 'open',
        done_at: null,
      }
    },
    submitMovement() {
      if (this.$refs.movementForm.validate()){
        this.loading = true
        let {value, due_date, ...mov} = this.new_movement
        due_date = this.$dayjs(due_date).add(12, 'hour').format()
        value = Number(value.replace(/,/g, ''))*100
        Api.Movement.create({...mov, value, due_date}).then(r=>r.data).then(d=> {
          console.log({d});
          this.$refs.movementForm.reset()
          this.$emit('done')
        }).catch(err=> {
          console.log({err});
        }).finally(()=> {
          this.loading = false
        })
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>